import genericValidationMethods, { getValidationState } from './genericValidation';

export function PTRequirementsValidation() {
  this.rules = {
    name: {
      validationMethod: 'getBooleanValidationState',
      errorMsg: 'Secondary Education is required for the PT program',
      id: 'hsOrGED'
    }
  };
  this.getValidationStatus = getValidationState.bind(this);
  this.getBooleanValidationState = genericValidationMethods.getBooleanValidationState;
}

export default PTRequirementsValidation;